exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-6bc3eeac]{vertical-align:text-bottom}.title[data-v-6bc3eeac]{min-height:40px;display:flex;align-items:center;font-weight:700}.feedback-optional-actions .btn[data-v-6bc3eeac]{min-width:170px}", ""]);

// exports
